import { useMemo } from "react";
import { forecastPortfolio, type Scenario } from "@aus-property/core";
import { useAppStore } from "@/app/store";

export const useForecasts = (selectedScenario: Scenario | null) => {
  const portfolio = useAppStore((store) => store.state.portfolio);

  return useMemo(() => {
    const baseline = forecastPortfolio(portfolio);
    const scenario = selectedScenario
      ? forecastPortfolio(portfolio, selectedScenario)
      : null;

    return {
      baseline,
      scenario
    };
  }, [portfolio, selectedScenario]);
};
